import React, { useState } from 'react';
import PropTypes from 'prop-types';
import OutputErrors from 'components/Inputs/outputErrors';
import { Button } from 'xland-ui';
import { ArrowLeft } from 'lucide-react';
import InputEmail from 'components/Inputs/inputEmail';
import { useSelector } from 'react-redux';
import useDialog from 'components/Dialog/useDialog';
import FormLayout from 'layouts/FormLayout';

function RecoveryForm({ literals, onRecovery, onBack }) {
  const [email, setEmail] = useState(window?.LOCAL_USER?.email || '');
  const recoveryError = useSelector(state => state.login.recoveryError);
  const { dialog } = useDialog();

  const recovery = async (e) => {
    e.preventDefault();

    onRecovery(email).then((success) => {
      if (success) {
        dialog({
          type: 'alert',
          text: literals.recovery.successMessage,
        });
      }
    });
  };

  const onEnterKeyPress = (e) => {
    if (e.charCode === 13 || e.keyCode === 13) {
      recovery(e);
    }
  };

  return (
    <FormLayout title={literals.recovery.title} className='form-auth'>
      <form className='form' onSubmit={recovery} onKeyPress={onEnterKeyPress}>
        <InputEmail
          preText={literals.email}
          placeholder={literals.email}
          isRequired
          value={email}
          onChange={value => setEmail(value)}
        />
        <OutputErrors errors={recoveryError} literals={literals} />
        <div className='form-actions'>
          <Button
            text={literals.recovery.button}
            type='submit'
            disabled={email === ''}
          />
          <div onClick={onBack} className='mt-3 pointer'>
            <ArrowLeft size={14} className='me-2' />
            {literals.recovery.back}
          </div>
        </div>
      </form>
    </FormLayout>
  );
}

RecoveryForm.propTypes = {
  literals: PropTypes.object.isRequired,
  onRecovery: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default RecoveryForm;
